// The return target comes only from the current, same-origin portal, never a
// caller-provided redirect. OAuth parameters must not survive into a new login.
export function getPortalUrl(href, startLogin = false) {
  const url = new URL(href);
  if (!/^\/groovesell\/promo-tools\/[A-Za-z0-9_-]+\/?$/.test(url.pathname)) {
    throw new Error('Invalid affiliate portal URL');
  }
  ['code', 'state', 'session_state', 'iss', 'error', 'error_description', 'portal_login'].forEach(key => url.searchParams.delete(key));
  url.hash = '';
  if (startLogin) url.searchParams.set('portal_login', '1');
  return url.href;
}
